export default __webpack_public_path__ + "static/media/6.guitsetgel.d0af30f4.png";